import { fetchFromHandinger } from "./fetchFromHandinger"
import { dirHandle } from "./storageShared"

async function fetchAndSave(id: string, url: string, jwt: string | undefined) {
  if (!url) return null
  if (!jwt) return null

  const directoryHandle = await dirHandle()
  const fileHandle = (await directoryHandle.getFileHandle(id, {
    create: true,
  })) as any // TODO: typescript is broken
  const syncHandle = await fileHandle.createSyncAccessHandle()

  try {
    const response = await fetchFromHandinger({
      params: {
        url,
        inline_images: "true",
        clean_content: "true",
        advanced_scraping: "true",
      },
      handler: "markdown",
      jwt,
    })

    if (!response.ok) {
      throw new Error("There was a problem fetching the file.")
    }

    const arrayBuffer = await response.arrayBuffer()

    syncHandle.write(arrayBuffer, { at: 0 })
  } catch (err) {
    console.error(err)
  } finally {
    await syncHandle.flush()
    await syncHandle.close()
  }

  return fileHandle
}

async function removeFile(id: string) {
  const directoryHandle = await dirHandle()
  if (id.includes("crswap")) return
  await directoryHandle.removeEntry(id)
}

async function getFileHandle(id: string) {
  try {
    const directoryHandle = await dirHandle()
    return await directoryHandle.getFileHandle(id)
  } catch (err) {
    console.error(err)
    return null
  }
}

async function findOrCreate(id: string, url: string, jwt: string | undefined) {
  let fileHandle = await getFileHandle(id)

  if (!fileHandle) {
    fileHandle = await fetchAndSave(id, url, jwt)
  }

  if (!fileHandle) return

  let fileData = await fileHandle.getFile()

  // this is for old versions of safari or corrupt files...
  if (fileData.size === 0) {
    fileHandle = await fetchAndSave(id, url, jwt)
    if (!fileHandle) return
    fileData = await fileHandle.getFile()
  }

  return await fileData.text()
}

self.addEventListener("message", async event => {
  const { id, type, args } = event.data

  switch (type) {
    case "findOrCreate": {
      const html = await findOrCreate(args.id, args.url, args.jwt)
      self.postMessage({ id, response: html })
      break
    }
    case "fetchAndSave":
      await fetchAndSave(args.id, args.url, args.jwt)
      self.postMessage({ id })
      break
    case "removeFile":
      await removeFile(args.id)
      self.postMessage(id)
      break
  }
})
